import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCar7Ev: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="car-7-ev, pickup"><path d="M19.75 17.25H22.25V9.75L18 8.75L15 4.75H8.75V9.75H1.75V17.25H4.25" stroke="currentColor" strokeWidth="1.5"/><path d="M9.75 17.25H14.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="7" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="17" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M15.75 10.25H13.5972L13.9445 8L10.75 11.75H12.9028L12.5556 14L15.75 10.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCar7Ev;
